import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-guide",
  "use": "icon-cms-guide-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-guide\"><path d=\"M130,207.93,97.24,128.76,18.07,96l152.82-63.3a17.18,17.18,0,0,1,22.44,22.44ZM41.59,96l62.54,25.9L130,184.41,185,51.67A8.17,8.17,0,0,0,174.33,41Z\" /><rect x=\"92.63\" y=\"101.37\" width=\"55\" height=\"9\" transform=\"translate(-39.68 115.95) rotate(-45)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol